(() => {
    const header_92x = document.querySelector('.header-wrapper');
    const disclosures_92x = document.querySelectorAll('.mobile-facets__disclosure');
    const mq_92x = window.matchMedia('(max-width: 749px)');

    function syncZ_92x() {
        if (!mq_92x.matches) {
            header_92x.style.zIndex = '9'; // reset for desktop
            return;
        }

        header_92x.style.zIndex =
            [...disclosures_92x].some(el => el.open) ? '1' : '9';
    }

    // run initially
    syncZ_92x();

    // run on toggle
    disclosures_92x.forEach(el => el.addEventListener('toggle', syncZ_92x));

    // run when screen size changes
    mq_92x.addEventListener('change', syncZ_92x);
})();